export default "__VITE_ASSET__BQRvdcHA__"